import { FC, useEffect, useState } from 'react';

import { isEmpty } from 'lodash';

import { Button, NumberInput, Text, VSpacing } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';

import { fetchBannerModerationInfo } from 'components/Admin/BannerModerationInfo/fetchBannerModerationInfo';
import { Banner } from 'components/Admin/ModerationList/CampaignModeration/Banner/Banner';

import { resetBannerModerationInfo } from 'store/models/moderation';
import { useDispatch, useSelector } from 'store/utils';

import styles from 'components/Admin/BannerModerationInfo/BannerModerationInfo.module.less';

const TrlKeys = {
    title: 'admin.bannerModerationInfo.title',
    inputPlaceholder: 'admin.bannerModerationInfo.input.placeholder',
    inputSearch: 'admin.bannerModerationInfo.input.search',
    searchResults: 'admin.bannerModerationInfo.searchResults',
    emptySearchResult: 'admin.bannerModerationInfo.emptySearchResult',
};

const MAX_BANNER_ID_LENGTH = 10;

export const BannerModerationInfo: FC = () => {
    const [value, setValue] = useState('');

    const trls = useTrls();
    const dispatch = useDispatch();

    const { bannerModerationInfo, isLoading } = useSelector((state) => state.moderation);

    useEffect(() => {
        return () => {
            dispatch(resetBannerModerationInfo());
        };
    }, [dispatch]);

    return (
        <>
            <Text typography="title-2-semibold">{trls(TrlKeys.title)}</Text>
            <VSpacing default={24} />
            <div className={styles.input}>
                <NumberInput
                    value={value}
                    onChange={setValue}
                    placeholder={trls(TrlKeys.inputPlaceholder)}
                    maxLength={MAX_BANNER_ID_LENGTH}
                    groupSize={Infinity}
                    allowNegative={false}
                    clearable
                    decimalMark={[]}
                    decimalLength={0}
                    data-qa="banner-moderation-info-input"
                />
                <Button
                    mode="primary"
                    style="accent"
                    onClick={() => {
                        value &&
                            dispatch(
                                fetchBannerModerationInfo({
                                    bannerId: Number(value),
                                    callback: () => setValue(''),
                                })
                            );
                    }}
                    loading={isLoading}
                    data-qa="banner-moderation-info-search-button"
                >
                    {trls(TrlKeys.inputSearch)}
                </Button>
            </div>
            <VSpacing default={44} />
            {bannerModerationInfo !== null && (
                <>
                    <Text style="secondary" typography="title-5-semibold">
                        {trls(TrlKeys.searchResults)}
                    </Text>
                    <VSpacing default={16} />
                    {!isEmpty(bannerModerationInfo) ? (
                        <Banner banner={bannerModerationInfo} />
                    ) : (
                        <Text>{trls(TrlKeys.emptySearchResult)}</Text>
                    )}
                    <VSpacing default={24} />
                </>
            )}
        </>
    );
};
